import React from "react";
import EmployeeEngagementbanner from "../../AVHRBanner/EmployeeManagementbanner.png";
import "../OurServicesCss/Services.css";
import { Card } from "primereact/card";
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";

function EmployeeEngagement() {
  const navigate = useNavigate();

  const handleNavigate = (path) => {
    navigate(path);
    window.scrollTo(0, 0);
  };
  return (
    <>
      <div style={{ paddingTop: "100px" }}>
        <div className="relative w-full h-[400px] sm:h-[500px] md:h-[600px] lg:h-[700px] xl:h-[800px] banner">
          <img
            src={EmployeeEngagementbanner}
            className="absolute inset-0 w-full h-full object-cover"
            alt=""
          />

          {/* Centered Content */}
          <div className="relative z-10 flex items-center justify-center h-full px-4 text-adjest">
            <div className="text-bannar max-w-3xl text-left avhrProject-bannerTextColour-B">
              <p className="edu-support-text uppercase">Our Services</p>

              <h1 className="career-library-heading">Employee Engagement</h1>

              {/* <p className="mt-4 leading-relaxed">
                
              </p> */}
            </div>
          </div>
        </div>

        <div className="grid justify-content-center align-items-stretch mt-4 gap-4 px-3 md:px-4">
          <div className="col-12 md:col-5 lg:col-4 p-3 ">
            <div
              className="shadow-4 p-4 h-full card-hover-effect"
              style={{ borderRadius: "10px", backgroundColor: "#ec6a52" }}>
              <h3 className=" mb-2 avhrProject-h3">
                Customized Solutions for Each Employee
              </h3>
              <p className="avhrProject-p">
                Every employee is unique — our solutions are too. We align
                support with individual roles, needs, and aspirations
              </p>
            </div>
          </div>

          <div className="col-12 md:col-5 lg:col-4 p-3">
            <div
              className="shadow-4 p-4 h-full card-hover-effect"
              style={{ borderRadius: "10px", backgroundColor: "#918fd0" }}>
              <h3 className=" mb-2 avhrProject-h3">
                Engaged Workforce, Flourishing Corporation
              </h3>
              <p className="avhrProject-p">
                Experience the transformative power of engaged employees. With
                our Employee Engagement Services, you’ll not only enhance
                workplace satisfaction but also drive productivity, innovation,
                and success
              </p>
            </div>
          </div>

          <div className="col-12 md:col-5 lg:col-4 p-3">
            <div
              className="shadow-4 p-4 h-full card-hover-effect"
              style={{ borderRadius: "10px", backgroundColor: "#FFC107" }}>
              <h3 className=" mb-2 avhrProject-h3">
                Employee Assistance Programs (EAP)
              </h3>
              <p className="avhrProject-p">
                Support your team through life’s challenges with our EAP
                services. We provide confidential counseling and resources to
                help employees navigate personal and professional issues
              </p>
            </div>
          </div>

          <div className="col-12 md:col-5 lg:col-4 p-3">
            <div
              className="shadow-4 p-4 h-full card-hover-effect"
              style={{ borderRadius: "10px", backgroundColor: "#FFA07A" }}>
              <h3 className=" mb-2 avhrProject-h3">
                Boosting Employee Well-Being
              </h3>
              <p className="avhrProject-p">
                Content and healthy employees exhibit greater productivity and
                engagement. Our services encompass employee well-being,
                nurturing a work atmosphere that fosters satisfaction
              </p>
            </div>
          </div>
        </div>

        <div className="w-full px-4 py-4 sm:px-6 md:px-10 lg:px-16">
          <Card
            className="CARDCOLOUR m-3"
            style={{
              background: "linear-gradient(120deg, #fb8f47, #f86aad)",
            }}>
            <p className="mb-2 text-center avhrProject-p">Get Started</p>
            <h2 className="mt-2 text-center avhrProject-h2">
              Fostering a culture where every voice is heard and every effort is
              valued
            </h2>

            <div className="flex justify-content-center">
              <Button
                label="Contact Us"
                rounded
                onClick={() => handleNavigate("/contactus")}
                className="buttonAvhrProject"
              />
            </div>
          </Card>
        </div>
      </div>
    </>
  );
}

export default EmployeeEngagement;
